import { useQuery } from "@tanstack/react-query";
import { ProjectResponse } from "../../../types/project";
import { ApiError } from "../../../types/apiError";
import { getProjectsOfUser } from "../api/getProjectsOfUser";

interface Params {
  appUserUuid?: string | null;
  page?: number;
  size?: number;
  search?: string;
}

export const useProjectsOfUserQuery = ({
  appUserUuid,
  page = 0,
  size = 20,
  search
}: Params) =>
  useQuery<ProjectResponse, ApiError>({
    queryKey: ["projects-of-user", appUserUuid, page, size, search],
    queryFn: () => {
      if (!appUserUuid) {
        throw new Error("Missing appUserUuid");
      }
      return getProjectsOfUser(appUserUuid, page, size, search);
    },
    enabled: Boolean(appUserUuid),
  });
